import { render } from "./IdCardAnalysisModal.vue?vue&type=template&id=435bb442"
import script from "./IdCardAnalysisModal.vue?vue&type=script&lang=js"
export * from "./IdCardAnalysisModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./IdCardAnalysisModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_6367f6cc%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2FIdCardAnalysisModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__